import classNames from 'classnames';
import { _ } from '/@/locale';
import styles from './styles.module.css';

export const ZoneDisplay = ({ name, codename }) => {
    return (
        <div className={styles.root}>
            {name && <div className={styles.name}>{_(name)}</div>}
            <div className={classNames(styles.map, styles[codename])} />
        </div>
    );
};
